<div class="publish-content" (click)="sendToReviewIfConnection()">
  <i class="app-icon-publish icon-publish" [class.disabled]="publishIsDisabled"></i>
  <span class="publish-text" [class.disabled]="publishIsDisabled">{{ 'TOOLTIP.SEND_FOR_REVIEW' | translate }}</span>
</div>
<div class="right-content">
  <i class="app-icon-edit-pencil" (click)="editExample()"></i>
  <i class="app-icon-bin icon-trash" (click)="removeExample()"></i>
</div>
